import { render, staticRenderFns } from "./PolicyRateForm.vue?vue&type=template&id=5e65c5b5"
import script from "./PolicyRateForm.vue?vue&type=script&lang=js"
export * from "./PolicyRateForm.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports